package com.upcominds.expedite.data.auth

data class OidcConfig(
    val issuer: String,        // https://keycloak.example.com/realms/MyRealm
    val clientId: String,      // π.χ. "mobile-app"
    val redirectUri: String,   // π.χ. "myapp://auth-callback"
    val scope: String = "openid profile email",
    val clientSecret: String? = null // optional: used for confidential clients (not recommended on mobile)
)